import { type PurchaseHandover } from "../../lib/api";
import { ITEM_HANDOVER_LABELS } from "../../data/itemTypes";
import { formatPhp } from "../../lib/money";

export function HandoverSummary({ terms, proposed = false }: { terms: PurchaseHandover; proposed?: boolean }) {
  return <div className="rounded-xl border border-line bg-navy-50 p-4 text-sm">
    <h3 className="font-bold text-navy">{proposed ? "Proposed handover" : terms.quoteId ? "Agreed handover" : "Default pickup"}</h3>
    <dl className="mt-2 space-y-2">
      {(proposed || terms.quoteId || terms.method !== "pickup") && <div><dt className="text-xs text-mut">Method</dt><dd className="font-semibold">{ITEM_HANDOVER_LABELS[terms.method]}</dd></div>}
      <div><dt className="text-xs text-mut">Location</dt><dd className="whitespace-pre-wrap break-words">{terms.location}</dd></div>
      {terms.schedule && <div><dt className="text-xs text-mut">{terms.quoteId ? "Schedule" : "Collection hours"}</dt><dd className="whitespace-pre-wrap break-words">{terms.schedule}</dd></div>}
      {terms.fee > 0 && <div><dt className="text-xs text-mut">Handover fee</dt><dd>{formatPhp(terms.fee)} · included in total</dd></div>}
      {terms.note && <div><dt className="text-xs text-mut">Notes</dt><dd className="whitespace-pre-wrap break-words">{terms.note}</dd></div>}
    </dl>
  </div>;
}
